module.exports = __webpack_public_path__ + "images/newerp_button2.1782880901430.png";